// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__NmKS8","icon":"CustomDragPreview_icon__v+c++","label":"CustomDragPreview_label__78rjg"};